import { DependencyList, useMemo } from 'react';

export const useDeepCompareMemo = <T>(factory: () => T, deps: DependencyList | undefined) => {
  const depsKey = JSON.stringify(deps);

  //  eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => factory(), [depsKey]);
};
